// extracted by mini-css-extract-plugin
export default {"header":"HeaderStyle_header__Sf6pk","nav_ul":"HeaderStyle_nav_ul__7B+VB","li":"HeaderStyle_li__DENLy","link":"HeaderStyle_link__zRxfm","logo":"HeaderStyle_logo__HYeGK"};